module.exports = __webpack_public_path__ + "img/Umthi.ad50fa53.png";